<template>
  <div class="fieldset">
    <h3 class="fieldset-heading">Children</h3>
    <ChildrenYN
        v-model="form.children_have"
        :children="form.children"
        :number-of-children="form.profileChildrenNumber"
        @numberOfChildren="form.profileChildrenNumber=$event"
    />
    <div v-if="form.children_have" class="question-box with-arrow">
      <ChildrenShort
          v-model="form.children"
          :number-of-children="form.profileChildrenNumber"
          @numberOfChildren="form.profileChildrenNumber=$event"
          @refresh="refresh"
          ref="childrenShort"
      />
    </div>
    <Pregnant v-model="form.profilePregnant"/>
    <div v-if="form.profilePregnant" class="question-box with-arrow">
      <PregnantDate v-model="form.profilePregnantDueDate"/>
    </div>

  </div>
</template>

<script>
import {fieldsetHelpers} from "../../fieldsetHelpers";

import ChildrenYN from "../../../question/questions/clientProfile/people/ChildrenYN";
import ChildrenShort from "../../../question/questions/clientProfile/people/ChildrenShort";
import Pregnant from "../../../question/questions/clientProfile/people/Pregnant";
import PregnantDate from "../../../question/questions/clientProfile/people/PregnantDate";


export default {
  name: 'ChildrenEstatePlanningSimple',
  mixins: [fieldsetHelpers],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    PregnantDate,
    Pregnant,
    ChildrenShort,
    ChildrenYN

  },
  data() {
    return {
      label: 'Children' // used for steps progress
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  },
  methods: {
    refresh() {
      if ('childrenShort' in this.$refs && this.$refs.childrenShort) {
        this.$refs.childrenShort.get()
      }
      if ('dependantsShort' in this.$refs && this.$refs.dependantsShort) {
        this.$refs.dependantsShort.get()
      }
    }
  }
};
</script>
